//imports
import { HashRouter,Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Subscribe from './pages/Subscribe';
import OtpConfirm from './pages/OtpConfirm';
import Topups from './pages/topups/Topups'; 
import TopupCreate from './pages/topups/TopupCreate';
import Play from './pages/play/Play';
import PlayCreate from './pages/play/PlayCreate';
import ErrorBoundary from './components/ErrorBoundary';
import Transactions from './pages/transactions/Transactions';
import ServiceType from './pages/serviceType/ServiceType';
import ServiceTypeCreate from './pages/serviceType/ServiceTypeCreate';
import ServiceTypeEdit from './pages/serviceType/ServiceTypeEdit';
import SdpService from './pages/sdpService/SdpService';
import SdpServiceCreate from './pages/sdpService/SdpServiceCreate';
import SdpServiceEdit from './pages/sdpService/SdpServiceEdit';
import AppUsers from './pages/appUsers/AppUsers';
import AppUserCreate from './pages/appUsers/AppUserCreate';
import AppUserEdit from './pages/appUsers/AppUserEdit';
import Deposit from './pages/deposit/Deposit';
import DepositCreate from './pages/deposit/DepositCreate';
import DepositEdit from './pages/deposit/DepositEdit';
import Winning from './pages/winning/Winning';
import WinningCreate from './pages/winning/WinningCreate';
import WinningEdit from './pages/winning/WinningEdit';
import InteractiveSms from './pages/interactiveSms/InteractiveSms';
import SmsMessage from './pages/smsMessage/SmsMessage';
import DailyUsers from './pages/dailyUsers/DailyUsers';
import SmsMessageCreate from './pages/smsMessage/SmsMessageCreate';
import Client from './pages/client/Client';
import ClientCreate from './pages/client/ClientCreate';
import ClientEdit from './pages/client/ClientEdit';
import MaTravelPackage from './pages/maTravelPackage/MaTravelPackage';
import MaTravelPackageCreate from './pages/maTravelPackage/MaTravelPackageCreate';
import MaTravelPackageEdit from './pages/maTravelPackage/MaTravelPackageEdit';
import Mapackageitem from './pages/mapackageitem/Mapackageitem';
import MapackageitemCreate from './pages/mapackageitem/MapackageitemCreate';
import MapackageitemEdit from './pages/mapackageitem/MapackageitemEdit';
import Matravelpackageinclusion from './pages/matravelpackageinclusion/Matravelpackageinclusion';
import MatravelpackageinclusionCreate from './pages/matravelpackageinclusion/MatravelpackageinclusionCreate';
import MatravelpackageinclusionEdit from './pages/matravelpackageinclusion/MatravelpackageinclusionEdit';
import Matravelpackageexclusion from './pages/matravelpackageexclusion/Matravelpackageexclusion';
import MatravelpackageexclusionCreate from './pages/matravelpackageexclusion/MatravelpackageexclusionCreate';
import MatravelpackageexclusionEdit from './pages/matravelpackageexclusion/MatravelpackageexclusionEdit';
import MaTravelPackageDetails from './pages/maTravelPackage/MaPackageDetails';
import Invoices from './pages/invoices/Invoices';
import InvoiceCreate from './pages/invoices/InvoiceCreate';
import InvoiceEdit from './pages/invoices/InvoiceEdit';



function App(){
     return (
         <ErrorBoundary>
             <HashRouter>
                 <Routes>
                    <Route path="/login" element={<Login />}/>
                    <Route path="/otpConfirm" element={<OtpConfirm />}/>
                    <Route path="/subscribe" element={<Subscribe />}/>
                    <Route path="/" element={<Dashboard />}/>
                    <Route path="/topups" element={<Topups />}/>
                    <Route path="/topupCreate" element={<TopupCreate />}/>
                    <Route path="/play" element={<Play />}/>
                    <Route path="/playCreate" element={<PlayCreate />}/>
                    <Route path="/transactions" element={<Transactions />}/>
                    <Route path="/client" element={<Client />}/>
                    <Route path="/clientCreate" element={<ClientCreate />}/>
                    <Route path={`/client/:id/edit`} element={<ClientEdit />}/>
                    <Route path="/serviceType" element={<ServiceType />}/>
                    <Route path="/serviceTypeCreate" element={<ServiceTypeCreate />}/>
                    <Route path={`/serviceType/:id/edit`} element={<ServiceTypeEdit />}/>
                    <Route path="/sdpService" element={<SdpService />}/>
                    <Route path="/sdpServiceCreate" element={<SdpServiceCreate />}/>
                    <Route path={`/sdpService/:id/edit`} element={<SdpServiceEdit />}/>
                    <Route path="/appUsers" element={<AppUsers />}/>
                    <Route path="/dailyUsers" element={<DailyUsers />}/>
                    <Route path="/appUserCreate" element={<AppUserCreate />}/>
                    <Route path={`/appUser/:id/edit`} element={<AppUserEdit />}/>
                    <Route path="/deposit" element={<Deposit />}/>
                    <Route path="/depositCreate" element={<DepositCreate />}/>
                    <Route path={`/deposit/:id/edit`} element={<DepositEdit />}/>
                    <Route path="/winning" element={<Winning />}/>
                    <Route path="/winningCreate" element={<WinningCreate />}/>
                    <Route path={`/winning/:id/edit`} element={<WinningEdit />}/>
                    <Route path="/interactiveSms" element={<InteractiveSms />}/>
                    <Route path="/smsMessage" element={<SmsMessage />}/>
                    <Route path="/smsMessageCreate" element={<SmsMessageCreate />}/>
                    <Route path="/client" element={<Client />}/>
                    <Route path="/clientCreate" element={<ClientCreate />}/>
                    <Route path={`/client/:id/edit`} element={<ClientEdit />}/>
                    <Route path="/maTravelPackage" element={<MaTravelPackage />}/>
                    <Route path="/maTravelPackageCreate" element={<MaTravelPackageCreate />}/>
                    <Route path={`/maTravelPackage/:id/edit`} element={<MaTravelPackageEdit />}/>
                    <Route path="/mapackageitem" element={<Mapackageitem />}/>
                    <Route path="/mapackageitemCreate" element={<MapackageitemCreate />}/>
                    <Route path={`/mapackageitem/:id/edit`} element={<MapackageitemEdit />}/>
                    <Route path="/matravelpackageinclusion" element={<Matravelpackageinclusion />}/>
                    <Route path="/matravelpackageinclusionCreate" element={<MatravelpackageinclusionCreate />}/>
                    <Route path={`/matravelpackageinclusion/:id/edit`} element={<MatravelpackageinclusionEdit />}/>
                    <Route path="/matravelpackageexclusion" element={<Matravelpackageexclusion />}/>
                    <Route path="/matravelpackageexclusionCreate" element={<MatravelpackageexclusionCreate />}/>
                    <Route path={`/matravelpackageexclusion/:id/edit`} element={<MatravelpackageexclusionEdit />}/>
                    <Route path="/maPackageDetails/:id/details" element={<MaTravelPackageDetails />}/>
                    <Route path="/invoices" element={<Invoices />}/>
                    <Route path="/invoiceCreate" element={<InvoiceCreate />}/>
                    <Route path={`/invoice/:id/edit`} element={<InvoiceEdit />}/>

                </Routes>
             </HashRouter>
        </ErrorBoundary>
    );
}
export default App;